import { render, staticRenderFns } from "./homework.vue?vue&type=template&id=8c6c9e0e&scoped=true&"
import script from "./homework.vue?vue&type=script&lang=js&"
export * from "./homework.vue?vue&type=script&lang=js&"
import style0 from "./homework.vue?vue&type=style&index=0&id=8c6c9e0e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6c9e0e",
  null
  
)

export default component.exports